export default [
  { key: "{{d.comum.dataAtual}}", description: "Data atual (curta)" },
  { key: "{{d.comum.dataAtualExtenso}}", description: "Data atual por extenso" },
  { key: "{{d.comum.horaAtual}}", description: "Hora atual" },

  { key: "{{d.locacao.numero}}", description: "Número da locação" },
  { key: "{{d.locacao.identificacao}}", description: "Identificação da locação" },
  { key: "{{d.locacao.tipoLocacao}}", description: "Tipo da locação" },

  { key: "{{d.operacional.tipoMovimento}}", description: "Tipo do movimento (Saída / Retorno)" },
  { key: "{{d.operacional.dataMovimento}}", description: "Data do movimento" },
  { key: "{{d.operacional.horaMovimento}}", description: "Hora do movimento" },
  { key: "{{d.operacional.obsMovimento}}", description: "Observação do movimento" },
  { key: "{{d.operacional.localEntrega}}", description: "Local de entrega/retirada" },

  { key: "{{d.equipamento.codigo}}", description: "Código do equipamento" },
  { key: "{{d.equipamento.descricao}}", description: "Descrição do equipamento" },
  { key: "{{d.equipamento.patrimonio}}", description: "Patrimônio" },
  { key: "{{d.equipamento.quantidade}}", description: "Quantidade" },

  { key: "{{d.locacao.cliente.razaoSocialNome}}", description: "Razão social / Nome do cliente" },
  { key: "{{d.locacao.cliente.fantasiaApelido}}", description: "Nome fantasia / Apelido" },
  { key: "{{d.locacao.cliente.telefone}}", description: "Telefone do cliente" },
  { key: "{{d.locacao.cliente.email}}", description: "E-mail do cliente" },
  { key: "{{d.locacao.cliente.cidade}}", description: "Cidade do cliente" },

  { key: "{{d.locacao.colaborador.nome}}", description: "Nome do colaborador responsável" },
  { key: "{{d.locacao.colaborador.celular}}", description: "Celular do colaborador" },
  { key: "{{d.locacao.colaborador.email}}", description: "E-mail do colaborador" },
];

